import './Loading.scss';
import React, { FC, useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';

const useParentRelative = (active: boolean) => {
    const ref = useRef<HTMLDivElement>(null);
    useLayoutEffect(() => {
        if (!active) return;
        const parent = ref.current?.parentElement;
        if (!parent) return;

        const { position } = window.getComputedStyle(parent);
        const needsPosition = position === 'static';

        if (needsPosition) {
            parent.style.position = 'relative';
            return () => {
                parent.style.position = '';
            };
        }
    }, [active]);
    return ref;
};

interface LoadingProps {
    type?: 'screen' | 'page' | 'element';
    className?: string;
    variant?: 'beam';
}

const Loading: FC<LoadingProps> = ({ type = 'screen', className, variant }) => {
    const isPosFixed = type !== 'screen';
    const isBeam = variant === 'beam';
    const containerRef = useParentRelative(isPosFixed);
    const svgCount = isBeam ? 22 : 1;

    // (!) viewBox must be identical to viewBox in src/assets/images/logo-flowers.svg
    return (
        <div
            ref={containerRef}
            className={classNames(
                'Loading',
                `Loading-${type}`,
                {
                    'Loading-isBeam': isBeam,
                },
                className,
            )}
        >
            <div
                className={classNames('Loading_container', {
                    'Loading_container-isBeam': isBeam,
                })}
            >
                {[...Array(svgCount)].map((_, i) => {
                    const delay = i * 100; // 100ms offset per item
                    return (
                        <svg
                            key={i}
                            className="LogoSvg"
                            viewBox="0 0 658.83 790.83"
                            style={{ animationDelay: `${delay}ms` }}
                        >
                            <use href="#logo-symbol" />
                        </svg>
                    );
                })}
            </div>
        </div>
    );
};

export default Loading;
